const e = `Here are the translations into Italian:

Agree - D'accordo`, o = "Celebrate - Festeggia", t = "Completed - Completato", n = "Disagree - Non d'accordo", a = "Funny - Divertente", s = "Hi - Ciao", i = "Love - Amore", c = 'Wow - Wow (Note: "Wow" is often used in Italian as an exclamation of surprise or amazement, much like in English)', r = {
  agree: e,
  celebrate: o,
  completed: t,
  disagree: n,
  funny: a,
  hi: s,
  love: i,
  wow: c
};
export {
  e as agree,
  o as celebrate,
  t as completed,
  r as default,
  n as disagree,
  a as funny,
  s as hi,
  i as love,
  c as wow
};
